import { clsx } from 'clsx';
import type { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';

type PrimaryButtonProps = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
    size?: 'small' | 'normal';
    rounded?: boolean;
};

const PrimaryButton = ({ className, size, rounded, children, ...props }: PrimaryButtonProps) => (
    <button
        className={clsx(
            className,
            size === 'small' && 'px-1 py-1',
            size === 'normal' && 'px-6 py-3',
            props.disabled && 'hover:bg-opacity-100 cursor-not-allowed opacity-50',
            rounded === true && 'rounded-full bg-transparent p-1 text-inherit hover:bg-gray-100'
        )}
        type="button"
        {...props}
    >
        {children}
    </button>
);

export default PrimaryButton;
